import {IntlProvider} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

import * as i18n from '../../i18n/languages';
import SettingsStore from '../../stores/SettingsStore';

class Portal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: <div />,
  };

  componentDidMount() {
    this.nodeEl = document.createElement('div');
    document.body.appendChild(this.nodeEl);
    this.renderChildren(this.props);
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this.nodeEl);
    document.body.removeChild(this.nodeEl);
  }

  componentWillReceiveProps(nextProps) {
    this.renderChildren(nextProps);
  }

  renderChildren(props) {
    if (props.children) {
      const locale = SettingsStore.getFloodSettings('language');

      ReactDOM.render(
        <IntlProvider locale={locale} messages={i18n[locale]}>
          {props.children}
        </IntlProvider>,
        this.nodeEl
      );
    }
  }

  render() {
    return null;
  }
}

export default Portal;



// WEBPACK FOOTER //
// ./client/src/javascript/components/general/Portal.js